<template>
  <div id="PumpList" class="page product-list">
    <rate-feedback
        v-if="feedbackDialogVisible"
        :code="gjwCategoryCode"
        title="水泵"
        type="7"
        @close="closeFeedbackDialog" />
    <div class="search-box">
      <div class="search-block curve-block border-bottom-divide">
        <span class="label">性能</span>
         <curve-search
          ref="curveSearch"
          class="curve"
          :curve-form-items="curveFormItems"
          @curve-search="searchByCurve"
          @change-unit="onUnitChange" />
      </div>
      <div v-if="!brandCode" class="search-block border-bottom-divide">
        <span class="label">品牌</span>
        <div class="brand-content">
          <span
              v-for="item in brands"
              :key="item.brandCode"
              class="brand-tag"
              :class="{'active': selectBrand === item.brandCode, 'disabled': item.disabled}"
              @click="clickBrand(item)"
          >
            {{item.brandName}}
          </span>
        </div>
      </div>
      <div class="search-block border-bottom-divide">
        <span class="label keyword-label">筛选</span>
        <filter-search ref="filterSearch" :search-properties="searchProperties" @select="onFilterSelected" @change="handleShowFilterSearch" />
      </div>
    </div>
    <div class="result-row">
      <filter-result
        :gjw-category-code = "gjwCategoryCode"
        :curve-properties="curveProperties"
        :curve-search-names="['流量','扬程']"
        :product-properties="productProperties"
        :total-count="totalCount"
        @clear-curve-filter="clearCurveFilter"
        @clear-product-filter="clearProductFilter"
        @clear-deviation-filter="clearDeviationFilter"
        @clear-all-filters="clearAllFilters" />
    </div>
    <gjw-dimensions @height-changed="getTableBoxHeight">
      <div ref="tableBox" class="table-box">
        <el-table
            v-loading="productsLoading"
            :data="tableData"
            :max-height="tableHeight"
            class="row-click-table"
            style="width:100%;"
            @sort-change="onSortChange"
            @row-click="(row)=>toDetail(row)"
        >
          <el-table-column label="产品型号" prop="model" min-width="180px" fixed>
            <template v-slot="scope">
              <product-model-col :row="scope.row" @image-click="toDetail" @model-click="toDetail" />
            </template>
          </el-table-column>
          <el-table-column :label="`流量(${fluidLabel})`" prop="fluid" min-width="64px" sortable="custom">
            <template v-slot="scope">
              {{scope.row.fluidFmt}}
            </template>
          </el-table-column>
          <el-table-column
              v-if="searchWithCurveProperties"
              label="流量偏差率(%)"
              min-width="64px"
          >
            <template v-slot="scope">
              <deviation-value :row="scope.row" relate-prop="fluid"/>
            </template>
          </el-table-column>
          <el-table-column label="扬程(m)" prop="head" :formatter="fmtValue" min-width="64px" sortable="custom"/>
          <el-table-column
              v-if="searchWithCurveProperties"
              label="扬程偏差率(%)"
              min-width="64px"
          >
            <template v-slot="scope">
              <deviation-value :row="scope.row" relate-prop="head"/>
            </template>
          </el-table-column>
<!--          <el-table-column label="汽蚀余量(m)" prop="npsh" min-width="64px" sortable="custom"/>-->
          <el-table-column label="电机功率(kW)" prop="power" :formatter="fmtValue" min-width="64px" sortable="custom"/>
          <el-table-column label="效率(%)" prop="efficiency" :formatter="fmtValue" min-width="60px" sortable="custom"/>
          <el-table-column label="转速(rpm)" prop="speed" :formatter="fmtValue" min-width="60px" />
<!--          <el-table-column label="长度(mm)" prop="length" min-width="60px" />-->
<!--          <el-table-column label="宽度(mm)" prop="width" min-width="60px" />-->
<!--          <el-table-column label="高度(mm)" prop="height" min-width="60px" />-->
<!--          <el-table-column label="设备重量(kg)" prop="weight" min-width="60px" />-->
          <el-table-column label="操作" width="112px" fixed="right">
            <template v-slot="scope">
              <!-- <el-button v-if="!brandCode" plain class="table-button sub-primary" @click.stop="toSelected(scope.row, scope.$index)" :disabled="selectingIndex === scope.$index">选中</el-button> -->
              <el-tooltip v-if="showPlaceComp && !isFromEntrance" content="布置该产品构件" placement="top">
                <el-button plain class="table-button main-primary" @click.stop="toPlaceComponent(scope.row)">布置</el-button>
              </el-tooltip>
              <el-tooltip v-if="showPlaceCompG && !isFromEntrance" content="载入该产品构件" placement="top">
                  <el-button plain class="table-button main-primary" @click.stop="toLoadGcsComp(scope.row)">载入</el-button>
              </el-tooltip>
              <el-tooltip v-if="isFromEntrance" content="选中该产品构件" placement="top">
                  <el-button plain class="table-button main-primary" @click.stop="selectGcsComp(scope.row)">选中</el-button>
              </el-tooltip>
              <el-popover
                  v-if="showPlaceCompWeb"
                  popper-class="no-padding-popper"
                  placement="bottom-end"
                  width="300"
                  trigger="hover"
                  @show="showPopover(scope.row)">
                <source-list-popover :loading="resourceLoading" :resource="scope.row.resource" @handleClick="toDetail(scope.row)"/>
                <template #reference>
                  <el-button type="primary" plain class="table-button main-primary pop-button" @click.stop="toDetail(scope.row)">下载</el-button>
                </template>
              </el-popover>
            </template>
          </el-table-column>
          <template #empty>
            <span v-if="selectedBrandUrl">非常抱歉，由于产品数据较少，未查询到符合条件的产品，您可以<em class="empty-list-feedback" @click="toFeedback">联系厂家</em>，留下产品需求和联系方式，厂家收到需求后会与您联系</span>
            <span v-else>非常抱歉，由于产品数据较少，未查询到符合条件的产品，您可以填写<em class="empty-list-feedback" @click="toFeedback">反馈</em>，让我们帮您找到合适的产品</span>
          </template>
          <template #append>
            <div v-if="showUnsatisfiedInfo" class="feedback-info">
              <span v-if="selectedBrandUrl">以上结果都不满足您的选型需求？您可以<em class="empty-list-feedback" @click="toFeedback">联系厂家</em>，留下产品需求和联系方式，厂家收到需求后会与您联系</span>
              <span v-else>对选型结果不满意？您可以填写<em class="empty-list-feedback" @click="toFeedback">反馈</em>，让我们帮您找到合适的产品</span>
            </div>
          </template>
        </el-table>
        <el-pagination
            small
            style="text-align: right; margin-top: 4px;"
            @current-change="currentChange"
            :current-page="pageNo"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="totalCount">
        </el-pagination>
      </div>
    </gjw-dimensions>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import envCodes from '@/assets/js/envCodes'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import productListMixin from '@/mixins/productListMixin'
import productDetailMixin from '@/mixins/productDetailMixin'
import GjwDimensions from '@/components/lib/GjwDimensions'
import SourceListPopover from './components/SourceListPopover'
import DeviationValue from './components/DeviationValue.vue'
import ProductModelCol from './components/ProductModelCol.vue'
import CurveSearch from '@/views/products/components/CurveSearch'
import FilterSearch from '@/views/products/components/FilterSearch'
import FilterResult from '@/views/products/components/FilterResult'
import RateFeedback from './components/RateFeedback.vue'
import defaultViewMixin from '@/mixins/defaultViewMixin'
import Utils from '@/core/utils'
export default {
  name: 'PumpList',
  components: { GjwDimensions, SourceListPopover, DeviationValue, ProductModelCol, CurveSearch, FilterSearch, FilterResult, RateFeedback },
  mixins: [checkLoginMixin, productListMixin, defaultViewMixin, productDetailMixin],
  data() {
    return {
      gjwCategoryCode: envCodes.pumpCode,
      selectBrand: null,
      curveProperties: [],
      productProperties: [],
      productSeriesId: null,
      productSeriesName: null,
      pageNo: 1,
      pageSize: 20,
      tableBox: null,
      tableHeight: 0,
      selectingIndex: -1,
      orderBy: null,
      orderType: null,
      showFilterSearch: false,
      feedbackDialogVisible: false
    }
  },
  computed: {
    ...mapGetters({
      brands: 'pumpList/brands',
      tableData: 'pumpList/tableData',
      totalCount: 'pumpList/totalCount',
      productsLoading: 'pumpList/productsLoading',
      searchProperties: 'pumpList/searchProperties',
      curveFormItems: 'pumpList/curveFormItems',
      brandCode: 'brandCode',
      convertUnits: 'pumpList/convertUnits',
      // 由选型首页带过来的搜索条件
      currentBrands: 'fastSearch/currentBrands',
      curveSearchValues: 'fastSearch/curveSearchValues',
      propertySearchValues: 'fastSearch/propertySearchValues',
      existFeedbackVisit: 'pumpList/existFeedbackVisit',
      isFromEntrance: 'isFromEntrance',
    }),
    showUnsatisfiedInfo() {
      return this.tableData.length && this.tableData.length < 5
    },
    fluidLabel() {
      const specUnit = this.convertUnits.find((u) => u.code === envCodes.fluid)
      return specUnit ? specUnit.unit : 'm³/h'
    },
    selectedBrandUrl() {
      if (this.selectBrand) {
        const selectBrandItem = this.brands.find((item) => item.brandCode === this.selectBrand) || {}
        return selectBrandItem.brandUrl
      }
      return null
    }
  },
  created() {
    this.loadBrands({ gjwCategoryCode: this.gjwCategoryCode })
    this.loadAllProperties({ gjwCategoryCode: this.gjwCategoryCode })
    this.selectBrand = this.currentBrands
    this.curveProperties = [...this.curveSearchValues]
    this.productProperties = [...this.propertySearchValues]
    if (this.platform === 'r') {
      this.loadDefinitions({ gjw_category_code: this.gjwCategoryCode })
    }
    // 临时添加凯泉水泵独立页面，提前设置好query中的brandCode
    if (this.brandCode) {
      this.selectBrand = this.brandCode
    }
    this.getList()
  },
  methods: {
    ...mapMutations({
      setShopAnimation: 'setShowShopAnimation',
      updateUnit: 'pumpList/updateUnit',
    }),
    ...mapActions({
      loadBrands: 'pumpList/loadBrands',
      loadAggBrands: 'pumpList/loadAggBrands',
      loadAllProperties: 'pumpList/loadAllProperties',
      loadAggProperties: 'pumpList/loadAggProperties',
      loadProducts: 'pumpList/loadProducts',
      loadExistFeedbackVisit: 'pumpList/existFeedbackVisit',
    }),
    getTableBoxHeight(obj) {
      const height = obj.newValue - 30 > 0 ? obj.newValue - 30 : 30
      this.tableHeight = height.toFixed(0)
    },
    clickBrand(brand) {
      if (brand.disabled) { return }
      this.selectBrand = this.selectBrand === brand.brandCode ? null : brand.brandCode
      this.search()
    },
    closeFeedbackDialog() {
      this.feedbackDialogVisible = false
    },
    fmtValue(row, col) {
      const colProp = col.property
      return this.$fmtValue(row[colProp], '-')
    },
    /**
     * 获取产品列表和聚合属性列表
     * @param {Boolean} refreshProperty 是否刷新属性列表 默认需要处理
     */
    getList(refreshProperty = true) {
      const curveProperties = this.searchWithCurveProperties ? this.curveProperties.map((c) => {
        let value = c.value
        if (c.code === envCodes.fluid) {
          if (c.unit !== 'm³/h') {
            value = Utils.timesValue(value, 3.6, 2)
          }
        }
        return {
          code: c.code,
          value: value,
          deviationRate: c.deviationRate
        }
      }) : null
      let productProperties = this.productProperties.reduce((arr, p) => {
        if (p.code === 'productSeries') {
          this.productSeriesId = p.valueCode
          this.productSeriesName = p.valueName
        } else if (arr.some((s) => s.code === p.code)) {
          arr.find((f) => f.code === p.code).values.push(p.valueCode)
        } else {
          arr.push({
            code: p.code,
            parameterType: p.parameterType,
            queryType: p.queryType,
            values: [p.valueCode]
          })
        }
        return arr
      }, [])
      productProperties = productProperties.length ? productProperties : null
      if (productProperties) {
        productProperties = productProperties.filter((f) => f.code)
      }
      const params = {
        gjwCategoryCode: this.gjwCategoryCode,
        brandCode: this.selectBrand || null,
        productSeriesId: this.productSeriesId || null,
        productSeriesName: this.productSeriesName || null,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        curveProperties,
        productProperties,
        orderBy: this.orderBy,
        orderType: this.orderType
      }
      this.loadProducts(params).then(() => {
        this.searchTrack(params)
        if (refreshProperty) {
          // 重新聚合筛选条件
          const paramsForBrand = {
            gjwCategoryCode: this.gjwCategoryCode,
            // productSeriesId: this.productSeriesId || null,
            // curveProperties,
            // productProperties,
          }
          this.loadAggBrands(paramsForBrand)
          const paramsForProperties = {
            ...paramsForBrand,
            // brandCode: this.selectBrand || null,
          }
          // 筛选条件取消聚合
          if (localStorage.getItem('isSelect') !== '1') {
            this.loadAggProperties(paramsForProperties)
            this.loadAggProductSeries(paramsForProperties)
          }
        }
        const isNotDefaultSearchCondition = !!(this.selectBrand || this.productSeriesId || curveProperties || productProperties)
        if (isNotDefaultSearchCondition) {
          this.loadExistFeedbackVisit({ classification_code: this.gjwCategoryCode }).then(() => {
            if (!this.existFeedbackVisit) {
              setTimeout(() => {
                this.feedbackDialogVisible = true
              }, 2000)
            }
          })
        }
      })
    },
    search() {
      this.pageNo = 1
      this.getList()
    },
    // 开始查找
    searchByCurve(curveProperties) {
      this.curveProperties = curveProperties
      this.search()
    },
    currentChange(val) {
      this.pageNo = val
      this.getList(false)
    },
    // 选中项目
    async toSelected(row, index) {
      try {
        this.selectingIndex = index
        this.setShopAnimation(false)
        // 判断当前用户是否登录
        const res = await this.checkLogin()
        if (res) {
          const designProperties = this.getDesignProperties(row, true)
          const runtimeProperties = this.getRunTimeProperties(row, true)
          const payload = {
            productId: row.id,
            designProperties,
            runtimeProperties
          }
          await this.handleSelectProduct(payload)
          this.$nextTick(() => {
            this.setShopAnimation(true)
          })
          this.selectTrack({
            productId: row.id,
            gjwCategoryCode: envCodes.pumpCode,
            gjwCategoryName: '水泵',
            source: 'products'
          })
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.selectingIndex = -1
      }
    },
    /**
     * 设计点值整理(和风机不同)
     * 选中 记录的设计流量 单位 是 m³/h
     * 详情 则根据用户选择的来判断 可能是 m³/h 也可能是 L/s
    */
    getDesignProperties(row, isToSelect = false) {
      const values = {}
      // 设计点数据处理
      // 说明设计点有值
      this.curveProperties.forEach((item) => {
        values[item.code] = item.value
      })
      const searchFluidUnit = this.curveFormItems.find((c) => c.code === envCodes.fluid).suffix
      const inputFluidValue = values[envCodes.fluid]
      const searchFluidValue = searchFluidUnit === 'm³/h' ? inputFluidValue : Utils.timesValue(inputFluidValue, 3.6, 2)
      return [
        {
          codes: envCodes.fluid,
          name: '设计流量',
          sort: 1,
          unit: isToSelect ? 'm³/h' : searchFluidUnit,
          type: 'design',
          values: isToSelect ? searchFluidValue || '-' : inputFluidValue || null
        },
        {
          codes: envCodes.head,
          name: '设计扬程',
          sort: 2,
          unit: 'm',
          type: 'design',
          values: values[envCodes.head] || (isToSelect ? '-' : null)
        },
      ]
    },
    // 运行点整理
    getRunTimeProperties(row, isToSelect = false) {
      const emptyValue = isToSelect ? '-' : null
      return [
        {
          codes: envCodes.speed,
          name: '运行转速',
          sort: 1,
          unit: 'rpm',
          type: 'runtime',
          values: this.$fmtValue(row.speed, emptyValue)
        },
        {
          codes: envCodes.fluid,
          name: '运行流量',
          sort: 2,
          unit: 'm³/h',
          type: 'runtime',
          values: this.$fmtValue(row.fluid, emptyValue)
        },
        {
          codes: envCodes.head,
          name: '运行扬程',
          sort: 3,
          unit: 'm',
          type: 'runtime',
          values: this.$fmtValue(row.head, emptyValue)
        },
        {
          codes: envCodes.efficiency,
          name: '运行效率',
          sort: 4,
          unit: '%',
          type: 'runtime',
          values: this.$fmtValue(row.efficiency, emptyValue)
        }
      ]
    },
    // 产品查询埋点
    async searchTrack(params) {
      const productResult = []
      const brandResult = []
      if (this.tableData && this.tableData.length) {
        this.tableData.forEach((item) => {
          productResult.push({ id: item.id, name: `${item.name}_${item.model}` })
          if (item.brandName && !brandResult.includes(item.brandName)) {
            brandResult.push(item.brandName)
          }
        })
      }
      const curveProperties = this.searchWithCurveProperties ? this.curveProperties.map((c) => {
        return {
          code: c.code,
          value: c.value,
          deviationRate: c.deviationRate,
          unit: c.unit
        }
      }) : null
      const projectInfo = await this.getProjectInfo()
      this.$tracks({
        event: 'productQuery',
        params: {
          g_c_keyword: params.keyword,
          g_c_class_code: params.gjwCategoryCode,
          g_c_class_name: '水泵',
          g_c_property: {
            curveProperties: curveProperties,
            productProperties: params.productProperties,
          },
          g_c_brand_code: params.brandCode,
          g_c_product_series: params.productSeriesName,
          g_c_non_filter_condition: {
            page: params.pageNo,
            page_size: params.pageSize,
          },
          g_c_product_result: productResult,
          g_c_brand_result: brandResult,
          g_c_result_count: this.totalCount,
          g_c_order_by: params.orderBy,
          g_c_order_type: params.orderType,
          g_c_default_condition: this.defaultView,
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        }
      })
      // 只有第一次进入页面是缺省，再次打点都认为是false
      if (this.defaultView) {
        this.defaultView = false
      }
    },
    onSortChange({ prop, order }) {
      this.pageNo = 1
      if (order) {
        this.orderBy = prop === 'productSeriesName' ? prop : envCodes[prop]
        this.orderType = order === 'ascending' ? 'ASC' : 'DESC'
      } else {
        this.orderBy = null
        this.orderType = null
      }
      this.getList()
    },
    clearCurveFilter() {
      this.$refs.curveSearch.clearData()
      this.searchByCurve([])
    },
    clearDeviationFilter(deviation) {
      this.$refs.curveSearch.clearDeviation(deviation)
      const property = this.curveProperties.find((c) => c.code === deviation.code)
      if (property) { property.deviationRate = null }
      this.search()
    },
    clearProductFilter(product) {
      if (product.code === 'productSeries') {
        this.productSeriesId = null
        this.productSeriesName = null
      }

      this.productProperties = this.productProperties.filter((f) => !(f.code === product.code && f.valueCode === product.valueCode))

      this.$refs.filterSearch.updateSearchForm(product)
      // 重新请求产品列表和筛选条件
      this.search()
    },
    clearAllFilters() {
      this.$refs.curveSearch.clearData()
      this.curveProperties = []
      this.productProperties = []
      this.productSeriesId = null
      this.productSeriesName = null
      this.$refs.filterSearch.resetSearchForm()
      this.search()
    },
    /** 处理筛选逻辑 */
    onFilterSelected(select) {
      if (select.code === 'productSeries') {
        this.productSeriesId = select.valueCode
        this.productSeriesName = select.valueName
        this.productProperties = this.productProperties.filter((s) => s.code !== select.code)
        this.productProperties.push(select)
      } else {
        // 数据不为当前选中的大类
        this.productProperties = this.productProperties.filter((s) => select.some((item) => s.code !== item.code))
        if (!(select.length === 1 && select[0].valueCode === null)) {
          select.forEach((v) => {
            this.productProperties.push({ ...v })
          })
        }
      }

      this.search()
    },
    handleShowFilterSearch(val) {
      this.showFilterSearch = val
    },
    onUnitChange(item) {
      if (this.searchWithCurveProperties) {
        this.clearAllFilters()
      }
      this.updateUnit(item)
    },

  },
}
</script>

<style lang="less" scoped>

  .product-list{
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    .search-box, .result-row{
      flex: none;
    }
    .table-box{
      flex: 1 1 100px;
      overflow: hidden;
    }
    .empty-list-feedback{
      cursor: pointer;
      font-style: normal;
      font-weight: bold;
      color: @theme-color;
    }
  }
  .search-block{
    position: relative;
    display: flex;
    padding: 6px 0;
    line-height: 28px;
    .label{
      min-width: 56px;
    }

    .switch{
      margin: 4px 16px 4px 0;
    }
  }
  .brand-tag{
    display: inline-block;
    padding: 0 12px;
    cursor: default;
    &:hover{
      color: @theme-hover-color;
    }
    &.active{
      border-radius: 2px;
      color: @white;
      background: @theme-color;
    }
    &.active:hover{
      background: @theme-hover-color;
    }
    &.disabled{
      cursor: not-allowed;
      color: @theme-text-light;
    }
  }
  .result-row{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .result{
    height: 26px;
    line-height: 26px;
  }
  .feedback-info{
    height: 45px;line-height: 45px;
    text-align: center;
    position: relative;
    font-size: 12px;
    &::after{
      position: absolute;
      content: '';
      width: 100%;
      height: 1px;
      bottom: 0;
      left: 0;
      background-color: #ebeef5;
    }
  }
</style>
